import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { getStorage } from 'minimal-shared/utils';
import { I18nextProvider as Provider, initReactI18next } from 'react-i18next';

import { fallbackLng, i18nOptions } from './locales-config';

/**
 * [1] localStorage
 * Auto detection:
 * const lng = getStorage('i18nextLng')
 */
const lng = getStorage('i18nextLng', fallbackLng) as string;

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(resourcesToBackend((lang: string, ns: string) => import(`./langs/${lang}/${ns}.json`)))
    .init({ ...i18nOptions(lng), detection: { caches: ['localStorage'] } });

type Props = {
    children: React.ReactNode;
};

/**
 * Provides internationalization context to child components.
 *
 * This provider component uses i18next to manage translations and language preferences
 * throughout the application. Wrap your application components with this provider
 * to enable i18n functionality.
 *
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Child components that will have access to i18n context
 * @returns {JSX.Element} Provider component with i18n context
 */
export function I18nProvider({ children }: Props) {
    return <Provider i18n={i18next}>{children}</Provider>;
}
